import { createApp } from "vue";
//LAYOUT
import NavBar from "./layout/nav.vue";
import RowOne from "./home/rowone.vue";
import RowTwo from "./home/rowtwo.vue";
import MyToast from "./layout/ts_bs.vue";
//LAYOUT
//SARANA
import MenuSarana from "./sarana/menu.vue";
import Tablesarana from "./sarana/tablesarana.vue";
import FormSarana from "./sarana/form/lv.vue";
import DetailSarana from "./sarana/detail/detail_lv.vue";
//SARANA
//P2H
import TableP2H from "./sarana/tablep2h.vue";
//P2H
//MASTER P2H
import TableMasterP2H from "./sarana/tablemasterp2h.vue";
import FormP2hSarana from "./sarana/form/formp2hsarana.vue";
import FormMasterP2H from "./sarana/form/masterp2h.vue";
import FormMasterItemP2H from "./sarana/form/masteritemp2h.vue";
import TableMasterItemP2H from "./sarana/tablemasteritemp2h.vue";
import P2HForm from "./sarana/form/p2hform.vue";

//MASTER P2H
//AUTH
import LoginForm from "./auth/login.vue";
import RegisterForm from "./auth/register.vue";
import Formp2hsarana from "./sarana/form/formp2hsarana.vue";
//AUTH

//CEK LOG SARANA
import CekLogSarana from "./sarana/cekloksarana.vue";
import CekLogSaranaForm from "./sarana/form/ceklog.vue";
import CekLogSaranaDetail from "./sarana/detail/ceklog.vue";
//CEK LOG SARANA

//Service Sarana
import ServiceSarana from "./sarana/service.vue";
import ServiceSaranaForm from "./sarana/form/service.vue";
import ServiceSaranaDetail from "./sarana/detail/service.vue";
//Service Sarana

// Berita acara
import BeritaAcara from "./sarana/beritaacara.vue";
import BeritaAcaraForm from "./sarana/form/ba.vue";
import BeritaAcaraDetail from "./sarana/detail/ba.vue";
import BeritaAcaraLampiran from "./sarana/form/lampiran_ba.vue";

// Berita acara

//LandingMenus
import LandingMenus from "./home/landingpage.vue";
//Qr Codes View
import QrCodeView from "./sarana/detail/qrcode.vue";

const app = createApp({});

app.component("navbar", NavBar)
    .component("content-row-one", RowOne)
    .component("content-row-two", RowTwo)
    .component("my-toast", MyToast);

app.component("form-sarana", FormSarana)
    .component("table-sarana", Tablesarana)
    .component("menu-sarana", MenuSarana)
    .component("detail-sarana", DetailSarana);
    
app.component("p2h-table", TableP2H)
    .component("p2h-form", FormP2hSarana)
    .component("master-p2h-form", FormMasterP2H)
    .component("master-p2h-table", TableMasterP2H)
    .component("master-p2h-item-form", FormMasterItemP2H)
    .component("master-p2h-item-table", TableMasterItemP2H)
    .component("landing-p2h-form",P2HForm);

app.component("login-form", LoginForm).component("register-form", RegisterForm);

app.component("ceklog-sarana-table", CekLogSarana);
app.component("ceklog-sarana-form", CekLogSaranaForm);
app.component("ceklog-sarana-detail", CekLogSaranaDetail);

app.component("service-sarana-table", ServiceSarana);
app.component("service-sarana-form", ServiceSaranaForm);
app.component("service-sarana-detail", ServiceSaranaDetail);


app.component("berita-acara-table", BeritaAcara);
app.component("berita-acara-form", BeritaAcaraForm);
app.component("berita-acara-detail", BeritaAcaraDetail);
app.component("berita-acara-lampiran", BeritaAcaraLampiran);

app.component("landing-menus", LandingMenus);
app.component("qrcode-view", QrCodeView);

app.mount("#app");
